import React, { Component } from 'react';
import isEmpty from 'lodash/isEmpty';
import { getLocation } from '../../../../utilities/helperUtility';
import Select from '../../../../components/Common/Select';
import { getWidgetProducts } from '../../../../services/api';
import Translation from '../../../../utilities/localizationUtility';

export default class ProductSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bookingFields: [],
      products: [],
    };

    this.onProductChange = this.onProductChange.bind(this);
  }

  componentDidMount() {
    const { product } = this.props;

    if (product.widget_id) {
      getWidgetProducts(product.widget_id)
        .then(({ data: { booking_fields: bookingFields, products } }) => this.setState({ bookingFields, products }))
        .catch(() => this.setState({ products: [] }));
    } else {
      this.setState({ products: [product] });
    }
  }

  onProductChange(id) {
    const { bookingFields, products } = this.state;
    const {
      settings,
      fetchProduct,
      onTrigger,
      setConfiguration,
      setSelectedResource,
      setVariantsQuantity,
    } = this.props;
    const product = products.find((item) => item.id === id);
    const { resources } = product;
    const variant = product.variants[0];

    fetchProduct(product);
    setSelectedResource(resources.length === 1 ? resources[0] : null);
    setVariantsQuantity(`${variant.external_id}_quantity`);
    setConfiguration({ ...settings, product, bookingFields });
    this.resetLocation(product);

    if (onTrigger) {
      onTrigger('variantChanged', variant);
    }
  }

  resetLocation(product) {
    const { locations } = product;
    const {
      settings: { setting },
      setSelectedLocation,
      setTimeZone,
    } = this.props;
    const location = getLocation(locations, setting, { useDefault: true });

    if (isEmpty(location)) {
      setSelectedLocation(null);
      setTimeZone(window.bta.timeZone);
    } else {
      setSelectedLocation(location);
      setTimeZone(location.timezone);
    }
  }

  productOptions() {
    const { products } = this.state;

    return products.map(({ id, title }) => ({
      label: title,
      value: id,
    }));
  }

  render() {
    const { products } = this.state;
    const {
      bodyStyle,
      className,
      isDisabled,
      labelClass,
      product,
      selectStyles,
      settings,
      wrapperClass,
    } = this.props;
    const t = new Translation(settings);
    const productOptions = this.productOptions();

    return (
      <div className={wrapperClass}>
        <span className={labelClass} style={bodyStyle}>
          {t.key('productPrompt') || 'Select Product'}
        </span>
        <Select
          name="products"
          styles={selectStyles}
          className={className}
          value={product ? product.id : ''}
          options={productOptions}
          isDisabled={isDisabled}
          isClearable={false}
          isSearchable={false}
          onChange={this.onProductChange}
        />
      </div>
    );
  }
}
